import {
  AccountSetting03Icon,
  Agreement01Icon,
  AiUserIcon,
  BandageIcon,
  BankIcon,
  Briefcase05Icon,
  Car01Icon,
  ChildIcon,
  CircleLockCheck02Icon,
  CourseIcon,
  CourtLawIcon,
  CovidInfoIcon,
  CreditCardPosIcon,
  CreditCardValidationIcon,
  Doctor02Icon,
  Facebook02Icon,
  HealthIcon,
  Home01Icon,
  IdVerifiedIcon,
  IdentityCardIcon,
  InjectionIcon,
  JusticeScale01Icon,
  LabsIcon,
  Money03Icon,
  MoneyReceive02Icon,
  Mortarboard02Icon,
  Passport01Icon,
  PassportValidIcon,
  PoliceBadgeIcon,
  ProfileIcon,
  RegisterIcon,
  School01Icon,
  SignatureIcon,
  TaskEdit01Icon,
  TaxesIcon,
  TeacherIcon,
  Tick01Icon,
  ToolsIcon,
  TransactionHistoryIcon,
  UserAiIcon,
  UserBlock01Icon,
  UserCheck01Icon,
  UserIcon,
  WorkAlertIcon,
} from '@hugeicons/core-free-icons';

/**
 * Maps check type slugs to HugeIcons
 * @param {string} slug - The check type slug
 * @returns {React.Component} - The corresponding HugeIcon component
 */
export const getCheckTypeIcon = slug => {
  // Icon mapping for all check type slugs
  const iconMap = {
    // Reference Checks
    reference: UserCheck01Icon,
    custom_reference: UserCheck01Icon,

    // Personal Identity Verification Checks
    id_verification: IdentityCardIcon,
    ssn_trace_check: CircleLockCheck02Icon,

    // Sanctions and Anti-Money Laundering Checks
    aml_verification: MoneyReceive02Icon,
    aml_verification_check: MoneyReceive02Icon,

    // Criminal Record Checks
    moj: JusticeScale01Icon,
    acic_check: PoliceBadgeIcon,
    afp: PoliceBadgeIcon,
    afp_backy: PoliceBadgeIcon,
    afp_candidate_pays: PoliceBadgeIcon,
    federal_criminal: PoliceBadgeIcon,
    county_criminal: PoliceBadgeIcon,
    federal_county_criminal: PoliceBadgeIcon,
    criminal_check: PoliceBadgeIcon,
    police_vetting: PoliceBadgeIcon,
    au_wwcc: ChildIcon,

    // Civil & Legal History Checks
    nz_court_search: CourtLawIcon,
    civil_litigation: Agreement01Icon,

    // Financial & Corporate Regulatory Checks
    asic_banned_disqualified: UserBlock01Icon,
    asic_directorship: Tick01Icon,
    nz_banned_directors: UserBlock01Icon,
    nz_business_interests_check: Tick01Icon,
    nz_financial_regulatory_check: Money03Icon,
    au_financial_regulatory_check: Money03Icon,

    // Regulatory History Checks
    aacbo: UserAiIcon,
    facis_3: UserIcon,

    // Right to Work Checks
    right_to_work: Passport01Icon,
    vevo: Passport01Icon,
    uk_right_to_work: Passport01Icon,

    // Driver License Checks
    nzta: IdentityCardIcon,
    au_driver_license: IdentityCardIcon,
    us_motor_vehicle_records: Car01Icon,

    // Previous Employment Checks
    employment_verification: Briefcase05Icon,
    nj_pass_the_trash: School01Icon,

    // Education Qualifications Checks
    qualification: Mortarboard02Icon,
    education_verification: CourseIcon,

    // Professional License and Membership Checks
    au_professional_license: Briefcase05Icon,
    professional_license: Briefcase05Icon,
    nursing_register: Doctor02Icon,
    ahpra: RegisterIcon,
    nz_teachers_registration: TeacherIcon,
    au_teachers_verification: TeacherIcon,
    tax_practitioners_board_check: TaxesIcon,
    au_high_risk_work_license: WorkAlertIcon,
    white_card_verification: ToolsIcon,

    // Credit History Checks
    equifax: TransactionHistoryIcon,
    credit_history: CreditCardPosIcon,
    credit_check: CreditCardValidationIcon,
    nz_bankrupcy_and_insolvent_register_search: BankIcon,
    afsa: BankIcon,
    us_bankruptcy: BankIcon,
    international_bankruptcy_check: BankIcon,

    // Digital Footprint Checks
    social_media: Facebook02Icon,

    // Medical and Drug Screening Checks
    medical_booking: HealthIcon,
    air_nz_med_check: HealthIcon,
    habit_health: HealthIcon,
    kinnect_check: HealthIcon,
    lifecare: HealthIcon,
    nz_provide: AccountSetting03Icon,
    tdda: LabsIcon,
    au_vaccination_certification_check: InjectionIcon,
    nz_vaccination_certification_check: InjectionIcon,
    covid_verification: CovidInfoIcon,

    // Other Screening Checks
    candidate_questionnaire: TaskEdit01Icon,
    document_signing: SignatureIcon,
    acc: BandageIcon,
  };

  // Return the mapped icon or default to Tick01Icon if not found
  return iconMap[slug] || Tick01Icon;
};

export const getSectionIcon = code => {
  switch (code) {
    case 'personal_details':
      return AiUserIcon;
    case 'address':
      return Home01Icon;
    case 'verify_identity':
      return PassportValidIcon;
    case 'additional_details':
      return IdVerifiedIcon;
    case 'fcra':
      return Agreement01Icon;
    default:
      return ProfileIcon;
  }
};
